const ajuste_estimativa_de_matricula_reordenamento_alunos_novos = {
  path: "/ajuste-estimativa-de-matricula-reordenamento-alunos-novos",
  redirect: "/ajuste-estimativa-de-matricula-reordenamento-alunos-novos",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Ajuste Estimativa de Matrícula Alunos Novos",
  },
  children: [
    {
      path: "/ajuste-estimativa-de-matricula-reordenamento-alunos-novos",
      name: "ajuste-estimativa-de-matricula-reordenamento-alunos-novos",
      component: () =>
        import(
          "@/views/AjusteEstimativaDeMatriculaReordenamentoAlunosNovos/AjusteEstimativaDeMatriculaReordenamentoAlunosNovos.vue"
        ),
    },
  ],
};

export { ajuste_estimativa_de_matricula_reordenamento_alunos_novos };
